import { render, staticRenderFns } from "./type-payment-field.vue?vue&type=template&id=3583e8b5&scoped=true"
import script from "./type-payment-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./type-payment-field.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583e8b5",
  null
  
)

export default component.exports